import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import Slideshow2 from '../slider/Slideshow2'
import React from 'react'
import { SiJava, SiJavascript,SiCplusplus,SiPython,SiReact,SiNodedotjs,SiHtml5, SiCsswizardry, SiPhp} from "react-icons/si";
import ParticlesBackground1 from '../particles/ParticlesBackground1'
const titleArray = ['P','r','o','j','e','c','t','s']



const Progress = ({done,experience}) => {
	const [style, setStyle] = React.useState({});
	
	setTimeout(() => {
		const newStyle = {
			opacity: 1,
			width: `${done}%`
		}
		
		setStyle(newStyle);
	}, 800);
	
	return (
		<div className="progress">
			<div className="progress-done" style={style}>
				{experience}
			</div>
		</div>
	)
}

const Tech = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
    <ParticlesBackground1/>
      <div className="container tech-page">
        <div className="text-zone2">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['T', 'e', 'c', 'h', 'n', 'o', 'l', 'o','g','y']}
              idx={15}
            />
          </h1>
          <p2>
            My Programming Skills and Experience is Listed Below:
          </p2>
          <p2>
            <br/>
          < SiCplusplus size={"4rem"}/>
          < SiJava size={"4rem"}/>
          < SiPython size={"4rem"}/>
            <br/>
          <Progress done="65" experience="Intermediate+"/>
          <p3> * C++ Education: 4 years of College experience <br/>
          * Java Education: College Java course, Professional: Teaching Minecraft Java Modding ~6 months <br/>
          * Python Professional Experience: Qualcomm Software Auomation Developer ~2 months
          </p3>
          <br/>
          < SiJavascript size={"4rem"}/>
          < SiReact size={"4rem"}/>
          < SiNodedotjs size={"4rem"}/>
          <br/>
          <Progress done="50" experience="Begineer + "/>
          <p3> * JS Education: JavaScript Course, Professional: Teaching Web Development ~2 months, React & Node.js Projects</p3>
          <br/>
          < SiHtml5 size={"4rem"}/>
          < SiCsswizardry size={"4rem"}/>
          < SiPhp size={"4rem"}/>
          <br/>
          <Progress done="55" experience="Intermediate "/>
          <p3> * Education: Web development course, Front End Projects ~4months</p3>
          </p2>
        </div>

        <div className="right-zone">
          {/* <h2>          
            <AnimatedLetters
              letterClass={letterClass}
              strArray={titleArray}
              idx={15}
            />
  </h2> */}
            <Slideshow2/>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Tech
